import { Injectable } from '@angular/core';

/**
 *
 * Este service genera la data de los gráficos.
 * Se creo genericamente, pensando en poder re-utilizarlo
 * en varios componentes.
 *
 * @author Juan Camilo Martínez Henao
 * @date 18-Febrero-2019
 *
 */

@Injectable({
  providedIn: 'root'
})
export class DataGraficasService {

  private arrayLabels: any[] = []; // Guarda las etiquetas a mostrar en las gráficas.

  constructor() {}

  public getResponse( data: any ): AnalisisHabilidadEntity[] {

    const arrayKeys: any[] = []; // Se crea para poder recorrer las agrupaciones.
    const arrayDataSet: AnalisisHabilidadEntity[] = []; // Guarda la estructura Json necesaria para representar
    // los datos en los gráficos.

    /*
      En este ForEach guardo las Keys del Json
      traído del servicio, esto con el fin de poder
      crear el data para generar los gráficos.
    */
    Object.keys(data).forEach(data => {
      arrayKeys.push(data);
    });

    /*
      En este fragmento de código que viene a continuación
      se genera la data para los gráficos:

      { data : [], label '' }
    */
    if (arrayKeys != null) {
      // Se verifica si el array contiene las Keys del Json.

      /*
        Aquí se crea la data, donde el primer For, recorre
        el array que contiene las Keys para crear dentro los objetos
        necesarios que se representarán en la gráfica. El segundo For, es el
        encargado de llenar los objetos, teniendo en cuenta
        que cada objeto que se llene y se crea, corresponde a los datos
        de un trimestre.
      */
      for (let i = 0; i < arrayKeys.length; i++) {
        const arrayTemporal = data[arrayKeys[i]]; // Se guarda los arrays dependiendo de la Key.
        const analisisHabilidadEntity: AnalisisHabilidadEntity = { // Se crea un objeto cada vez que la key cambie.
          data: [],
          label: ''
        };

        for (let j = 0; j < arrayTemporal.length; j++) {
          /*
            Se guardan los Labels, los cuales representan los
            nombres visuales de las gŕaficas.
          */
          if (!this.arrayLabels.includes(arrayTemporal[j]['descripcion'])) {
            this.arrayLabels.push(arrayTemporal[j]['descripcion']);
          }

          /*
            Se llena el objeto con los datos correspondientes, como su array
            de valores (o data), y su label (Trimestre).
          */
          analisisHabilidadEntity.data.push(arrayTemporal[j]['valor']);
          analisisHabilidadEntity.label = 'Trimestre ' + (i + 1);

        }

        /*
          Se guarda el objeto en el array de la interface AnalisisHabilidadEntity.
        */
        arrayDataSet.push(analisisHabilidadEntity);
      }

      if (arrayDataSet != null) {
        return arrayDataSet;
      } else {
        return null;
      }
    }
  }

  public getArrayLabels(): any [] {
    return this.arrayLabels;
  }

}

/*
  La interface se crea para representar el objeto Json
  que se necesita para generar las gráficas.
*/

interface AnalisisHabilidadEntity {
  data: any[];
  label: string;
}
